import { authPost } from "../../common/redux/ApiClient";

const baseUrl = "35.240.204.237/es3KioskApi";

export function postAgent13(params) {
  return authPost(`${baseUrl}/Agent13.ashx`, params);
}

export function postAgent14(params) {
  return authPost(`${baseUrl}/Agent14.ashx`, params);
}
